import { isDefined } from '@fabric-app/utils/guards/index';

function createKeyValQueryStorage(storeName, keyValStorage) {
  return {
    getItem: async (key) => {
      return await keyValStorage?.getItem(storeName, key);
    },
    setItem: async (key, value) => {
      await keyValStorage?.setItem(storeName, key, value);
    },
    removeItem: async (key) => {
      await keyValStorage?.removeItem(storeName, key);
    }
  };
}
async function restoreQueryClientCache(storeName, keyValStorage, queryClient, buster, restored) {
  if (!keyValStorage) {
    return;
  }
  const loadQuery = (queryData) => {
    if (queryData.buster !== buster) {
      return;
    }
    if (!queryData.state.data) {
      return;
    }
    const state = queryClient.getQueryState(queryData.queryKey);
    if (state) return;
    queryClient.setQueryData(queryData.queryKey, (data) => {
      return !isDefined(data) ? queryData.state.data : void 0;
    }, {
      updatedAt: queryData.state.dataUpdatedAt
    });
  };
  for (const item of await keyValStorage.getAllItems(storeName)) {
    loadQuery(item);
  }
  restored();
}

export { createKeyValQueryStorage, restoreQueryClientCache };
//# sourceMappingURL=persister.js.map
